<div class="mat-elevation-z8 mb-10">
  @if (loading) {
  <app-spinner [isLoading]="loading"></app-spinner>
  } @else {
  <!-- Rows Per page -->
  @if (totalPages > 0) {
  <div class="d-flex align-items-center w-100 gap-2 mb-4">
    <label class="mb-0" for="pageSize">{{ "rows_per_page" | translate }}:</label>
    <select id="pageSize" [(ngModel)]="itemsPerPage" (change)="onChangeItemsPerPage($event)">
      <option *ngFor="let size of pageSizes" [value]="size">{{ size }}</option>
    </select>
  </div>
  }
  <div class="app-table-container">
    <table class="table table-responsive table-relative">
      @if (columnWidth.length) {
      <colgroup>
        @for (width of columnWidth; track $index) {
        <col [attr.style]="'width: ' + (width ? width : 'auto') + ';'" />
        }
        <col style="width: 10%" />
      </colgroup>
      }
      <thead>
        <tr>
          @for (header of headers; track $index) {
            <th
              class="text-center"
              [class.sortable]="header.key"
              (click)="header.key ? sortBy(header.key) : null"
            >
              {{ header.label | translate }}

              <span class="sort-by pull-right" *ngIf="header.key">
                @if (sortColumn === header.key) {
                  <i
                    class="fa"
                    [ngClass]="{
                      'fa-caret-up': sortOrder === 'ASC',
                      'fa-caret-down': sortOrder === 'DESC'
                    }"
                  ></i>
                } @else {
                  <i class="fa fa-caret-up"></i>
                  <i class="fa fa-caret-down"></i>
                }
              </span>
            </th>
          } @if (actions.length > 0) {
          <th class="text-center">{{ "actions" | translate }}</th>
          }
        </tr>
        @if (hasSearchableHeaders()) {
          <tr class="search-row">
            @for (header of headers; track $index) {
              <td class="text-center">
                @if (header?.searchable) {
                  <div class="search-input-container">
                    <input
                      type="text"
                      class="form-control form-control-sm search-input"
                      [placeholder]="getSearchPlaceholder(header.label)"
                      [value]="header.key ? (searchFilters[header.key] || '') : ''"
                      (keyup.enter)="header.key ? onSearchInput($event, header.key) : null"
                      (click)="$event.stopPropagation()" />

                    @if (header.key && searchFilters[header.key]) {
                      <button
                        type="button"
                        class="btn btn-sm btn-outline-secondary clear-search-btn"
                        (click)="clearSearch(header.key); $event.stopPropagation()">
                        <i class="fa fa-times"></i>
                      </button>
                    }
                  </div>
                }
              </td>
            }

            @if (actions.length > 0) {
              <td></td>
            }
          </tr>
        }
  </thead>
      <tbody>
        @if(data === null || data.length === 0) {
        <div class="d-flex justify-content-start">
          <p class="mt-2 mb-2">{{ customNoData | translate }}</p>
        </div>
        } @else { @for (item of getDisplayData(); track trackByItem($index, item)) {
        <tr>
          @for (header of headers; track $index) {
          <td [ngClass]="{ 'state-data': header.key === 'statusTranslated' && item.statusTranslated }">
            @if (header.html) {
            <span [innerHTML]="header.key ? renderSafeHtml(item[header.key], header.html) : ''"></span>
            } @else {
            <span
              [ngClass]="{
                uninvited: header.key === 'statusTranslated' && item.statusTranslated === 'statuses.not_registered',
                invited: header.key === 'statusTranslated' && item.statusTranslated === 'statuses.registered',
                registered: header.key === 'statusTranslated' && item.statusTranslated === 'statuses.invited',
                'checked-in': header.key === 'statusTranslated' && item.statusTranslated === 'statuses.redeemed'
              }">
              {{ header.key ? getItem(item, header.key, header?.translateValue ?? false) : '' }}
            </span>
            }
          </td>
          } @if (actions.length > 0) {
          <td>
            <app-table-action-buttons [id]="item.id">
              <app-table-generic-button
                *ngFor="let action of actions; trackBy: trackByAction"
                class="dropdown-item"
                [id]="'action-' + item.id + '-' + action.label"
                [label]="action.label | translate"
                (clicked)="action.handler(item)"
                [icon]="action.icon"></app-table-generic-button>
            </app-table-action-buttons>
          </td>
          }
        </tr>
        } }
      </tbody>
    </table>
  </div>

  @if (totalPages > 1) {
  <div class="mt-4 mb-4">
    <div class="pagination-container">
      <nav aria-label="Paginazione">
        <ul class="pagination">
          <!-- Pulsante Precedente -->
          <li class="page-item" [class.disabled]="currentPage === 1">
            <button class="page-link" (click)="onPageChange(currentPage - 1)" [disabled]="currentPage === 1">
              <i class="icon-angle-left"></i>
              <span>{{ "previous" | translate }}</span>
            </button>
          </li>

          <!-- Testo "Pagina X di Y" al centro -->
          <div class="pagination-number">
            <!-- Prima pagina (sempre visibile) -->
            <li [class.active]="currentPage === 1">
              <button class="page-link" (click)="onPageChange(1)">1</button>
            </li>

            <!-- "..." iniziale se serve -->
            <li *ngIf="totalPages > 7 && currentPage > 4" class="disabled">
              <span>&nbsp;...&nbsp;</span>
            </li>

            <!-- Pagine centrali -->
            <li *ngFor="let page of getVisiblePages()" [class.active]="page === currentPage">
              <button class="page-link" (click)="onPageChange(page)">{{ page }}</button>
            </li>

            <!-- "..." finale se serve -->
            <li *ngIf="totalPages > 7 && currentPage < totalPages - 3" class="disabled">
              <span>&nbsp;...&nbsp;</span>
            </li>

            <!-- Ultima pagina (sempre visibile) -->
            <li *ngIf="totalPages > 1" [class.active]="currentPage === totalPages">
              <button class="page-link" (click)="onPageChange(totalPages)">{{ totalPages }}</button>
            </li>
          </div>

          <!-- Pulsante Successivo -->
          <li class="page-item" [class.disabled]="currentPage === totalPages">
            <button class="page-link" (click)="onPageChange(currentPage + 1)" [disabled]="currentPage === totalPages">
              <span>{{ "next" | translate }}</span>
              <i class="icon-angle-right"></i>
            </button>
          </li>
        </ul>
      </nav>
    </div>
  </div>
  } }
</div>
